import { useEffect, useRef, useState } from "react";
import NiceModal from "@ebay/nice-modal-react";
import ModalBase from "modals/base/ModalBase";
import FlexChild from "layouts/flex/FlexChild";
import style from "./ContactUsModal.module.css";
import clsx from "classnames";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { isMobile } from "react-device-detect";
import emailjs from '@emailjs/browser';
import P from "layouts/wrapper/P";
import Axios from "axios";


const ContactUsModal = NiceModal.create(
    (props, ref) => {
        const fileDownload = require('js-file-download');

        const modal = useRef();
        const [withHeader, withFooter] = [true, false];
        const [width, height] = ["min(80%, 500px)", "70vh"];
        const withCloseButton = true;
        const clickOutsideToClose = false;
        const title = "고객문의";
        const buttonText = "close";

        const form = useRef();

        const sendEmail = (e) => {
            e.preventDefault();
            showSendingModal();
            emailjs.sendForm('worldintl_homepage', 'template_06ya96m', form.current, 'MNiW3fB8b1JQ3Jeje')
                .then((result) => {
                    modal.current.close();
                    NiceModal.show("contactUsSendingModal", { isSending: false });
                    // console.log(result.text);
                }, (error) => {
                    console.log(error.text);
                });
        };

        const showSendingModal = () => {
            NiceModal.show("contactUsSendingModal", { isSending: true });
        };


        const onDownloadClick = () => {
            download("/images.zip", "과일먹구싶오.zip");
        }

        const download = (url, filename) => {
            Axios.get(url, {
                responseType: 'blob',
            }).then(res => {
                fileDownload(res.data, filename);
            });
        }

        const ContactUsForm = () => {
            return (
                <div className={clsx(style.contactUsFormWrapper, { [style.mobile]: isMobile })}>
                    <div className={style.contactUsFormBackground}></div>
                    <div className={clsx(style.contactUsForm, { [style.mobile]: isMobile })}>
                        <form className={style.form} ref={form}>
                            <VerticalFlex gap={20}>
                                <FlexChild height={"10%"}>
                                    <div className={style.contactUsFormRow}>
                                        <div className={style.contactUsFormRowBackground}></div>
                                        <input className={style.input} placeholder={"성함"} type="text" name="name" autoComplete="off" />
                                    </div>

                                </FlexChild>
                                <FlexChild height={"10%"}>
                                    <div className={style.contactUsFormRow}>
                                        <div className={style.contactUsFormRowBackground}></div>
                                        <input className={style.input} placeholder={"이메일"} type="text" name="email" autoComplete="off" />
                                    </div>
                                </FlexChild>
                                <FlexChild height={"10%"}>
                                    <div className={style.contactUsFormRow}>
                                        <div className={style.contactUsFormRowBackground}></div>
                                        <input className={style.input} placeholder={"전화번호"} type="text" name="phoneNo" autoComplete="off" />
                                    </div>
                                </FlexChild>
                                <FlexChild height={"30%"}>
                                    <div className={style.contactUsFormRow}>
                                        <div className={style.contactUsFormRowBackground}></div>
                                        <textarea className={style.input} placeholder={"문의내용"} type="text" name="message" autoComplete="off" />
                                    </div>
                                </FlexChild>
                                <FlexChild height={"10%"}>
                                    <div className={style.sendButton} onClick={sendEmail}>
                                        <P font={"Cafe24Ohsquareair"} size={"min(4vw, 15px)"}>보내기</P>
                                    </div>
                                </FlexChild>
                            </VerticalFlex>
                        </form>
                    </div>
                    <div className={style.imageDownloadArea} onClick={onDownloadClick}>
                        <P font={"Cafe24Ohsquareair"} size={"min(4vw, 15px)"} >이미지 일괄 다운로드</P>

                    </div>
                </div >
            );
        }

        return (
            <ModalBase ref={modal} width={width} height={height} withHeader={withHeader} withFooter={withFooter} withCloseButton={withCloseButton} clickOutsideToClose={clickOutsideToClose} title={title} buttonText={buttonText}>
                <ContactUsForm />
            </ModalBase>
        );
    }
);

export default ContactUsModal;